/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const HotelDetailsHeader: React.FC = () => {
  const t = Tr()
  const lang = useLang()
  const location = useLocation();
  const hotelId = (location.state as any)?.hotelId || '';
  const [hotelDetails, setHotelDetails] = useState([]);

  // hotel Details api call
  const hotelDetailsApiCall=async()=>{
    var param:any={
        hotelId:hotelId,
    }
    var response:any=await fetchData("public/hotelDetailsV2",param)
    if(response.status=="200")
    {
        setHotelDetails(response.data);
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    hotelDetailsApiCall()
  },[hotelId])
  return (
    <>
    {
      hotelDetails.map((hotel:any,index:any)=>{
        var imageUrl = '';
        var totalImage = '';
        if(hotel['images'].length != 0){
          imageUrl = hotel['images'][0].mediaPath;
          totalImage = '+'+(hotel['images'].length-1);
        }else{
          imageUrl = toAbsoluteUrl("/media/avatars/300-1.jpg");
          totalImage = '';
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {
                      totalImage ? (
                        <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white d-flex justify-content-center align-items-center fw-bold fs-4'>{totalImage}</div>
                      ):('')
                    }
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {getTranslatedValue(lang, hotel, '_name')}
                        </div>
                        <button
                          className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                        >
                          {getTranslatedValue(lang, hotel['subcategory'][0], '_name')}
                        </button>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='sms' className='fs-4 me-1' />
                          {hotel['email']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='phone' className='fs-4 me-1' />
                          {hotel['mobileNumber']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {hotel['location']}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{hotel['roomList'].length}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>{t('Room Count')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/hoteloverview/' && 'active')
                      }
                      to='../hoteloverview/'
                      state={{hotelId:hotelId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewroomslist/' && 'active')
                      }
                      to='../viewroomslist/'
                      state={{hotelId:hotelId}}
                    >
                      {t('Rooms')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    </>
  )
}

export {HotelDetailsHeader}
